<template>
  <div class="relative mb-4 mt-3">
    <div v-if="$slots.left" class="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 pointer-events-none">
      <slot name="left" />
    </div>
    <input
    ref="input"
      :type="type"
      :id="inputId"
      :disabled="disabled || loading"
      :placeholder="placeholder"
      v-model="inputValue"
      @click="handleClick"
      class="w-full rounded-full border px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-primary transition pr-12 w-full"
      :class="[
        { 'bg-gray-100 cursor-not-allowed': (disabled || loading) && !readonly },
        $slots.left ? 'pl-12' : '',
        danger ? 'border-red-500 focus:ring-red-500' : 'border-gray-200'
      ]"
      @input="$emit('input', inputValue)"
    />
    <label
      v-if="label"
      :for="inputId"
      class="absolute left-4 -top-0 bg-white px-2 text-gray-400 text-xs font-semibold pointer-events-none"
      style="transform: translateY(-50%);"
    >
      {{ label }}
    </label>
    <span v-if="loading" class="absolute right-4 top-1/2 transform -translate-y-1/2">
      <svg aria-hidden="true" class="inline w-6 h-6 text-primary animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="opacity-25" cx="50" cy="50" r="45" stroke="currentColor" stroke-width="10"/>
        <path class="opacity-75" fill="currentColor" d="M50 15a35 35 0 0135 35h10A45 45 0 0050 5v10z"/>
      </svg>
    </span>
    <div v-if="$slots.right" class="absolute right-4 top-1/2 transform -translate-y-1/2 z-10">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CuInput",
  props: {
    value: [String, Number],
    type: { type: String, default: "text" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    id: { type: String, default: null },
    danger: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    inputId() {
      return this.id || `cuinput-${this._uid}`;
    },
    
  },

  methods: {
    updateValue(v) {
      this.inputValue = v;
    },
    handleClick(){
      if(this.readonly){
        this.$refs.input.blur(); // Prevent focus if readonly
      }
    }
  },

  watch: {
    value(newValue) {
      this.inputValue = newValue;
    },  
  },

    data() {
        return {
        inputValue: this.value
        };
    },
};
</script>
